var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChiefofStaffHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Chief_of_Staff_-_Second",
    "data-name": "Chief of Staff - Second",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_133050",
    "data-name": "Path 133050",
    d: "M56.124,54.588l-.466-2.8-1.868,1.4Z",
    transform: "translate(13.448 12.947)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133051",
    "data-name": "Path 133051",
    d: "M58.093,49.98a6.268,6.268,0,0,0,3.384-5.111l.284-3.971a13.749,13.749,0,0,1-14.009-2.16l-1.71-1.426h-.532a7.963,7.963,0,0,0-.093,1.891l.405,5.665a6.267,6.267,0,0,0,3.385,5.111l-.884,1.385,5.328,4,5.327-3.995Z",
    transform: "translate(11.349 9.328)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133052",
    "data-name": "Path 133052",
    d: "M46.3,36.14a1.252,1.252,0,0,1,.8.29l2.057,1.715A11.4,11.4,0,0,0,60.9,39.791l.708-.3L61.646,39a7.959,7.959,0,0,0-7.9-7h-.583a7.95,7.95,0,0,0-6.981,4.139H46.3Z",
    transform: "translate(11.545 8)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133053",
    "data-name": "Path 133053",
    d: "M63.654,49.846l-.89-.254-1.4,1.054L62.484,57.4a1.25,1.25,0,0,1-1.877,1.276L55,55.309l-5.606,3.364A1.251,1.251,0,0,1,47.516,57.4l1.125-6.751-1.4-1.054-.89.254A8.749,8.749,0,0,0,40,58.258V67.6H70V58.258a8.749,8.749,0,0,0-6.346-8.412Z",
    transform: "translate(10 12.398)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133054",
    "data-name": "Path 133054",
    d: "M50.677,53.187l-1.868-1.4-.466,2.8Z",
    transform: "translate(12.086 12.947)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133055",
    "data-name": "Path 133055",
    d: "M16.124,54.588l-.466-2.8-1.868,1.4Z",
    transform: "translate(3.447 12.947)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133056",
    "data-name": "Path 133056",
    d: "M18.093,49.98a6.268,6.268,0,0,0,3.384-5.111l.284-3.971a13.749,13.749,0,0,1-14.009-2.16l-1.71-1.426H5.509A7.963,7.963,0,0,0,5.417,39.2l.405,5.665a6.267,6.267,0,0,0,3.385,5.111l-.884,1.385,5.328,4,5.328-3.995Z",
    transform: "translate(1.349 9.328)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133057",
    "data-name": "Path 133057",
    d: "M6.3,36.14a1.252,1.252,0,0,1,.8.29l2.058,1.715A11.4,11.4,0,0,0,20.9,39.791l.708-.3L21.646,39a7.959,7.959,0,0,0-7.9-7h-.582a7.95,7.95,0,0,0-6.981,4.139H6.3Z",
    transform: "translate(1.545 8)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133058",
    "data-name": "Path 133058",
    d: "M23.654,49.846l-.89-.254-1.4,1.054L22.484,57.4a1.25,1.25,0,0,1-1.877,1.276L15,55.309,9.394,58.673A1.251,1.251,0,0,1,7.516,57.4l1.125-6.751-1.4-1.054-.89.254A8.749,8.749,0,0,0,0,58.258V67.6H30V58.258a8.749,8.749,0,0,0-6.346-8.412Z",
    transform: "translate(0 12.398)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133059",
    "data-name": "Path 133059",
    d: "M10.677,53.187l-1.868-1.4-.466,2.8Z",
    transform: "translate(2.086 12.947)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133060",
    "data-name": "Path 133060",
    d: "M56.25,33.75a1.234,1.234,0,0,1-.479-.095A1.249,1.249,0,0,1,55,32.5V20h2.5v9.483l2.866-2.866,1.768,1.767-5,5A1.25,1.25,0,0,1,56.25,33.75Z",
    transform: "translate(13.75 5)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133061",
    "data-name": "Path 133061",
    d: "M60.75,20.75h-2.5v-5A6.257,6.257,0,0,0,52,9.5H42V7H52a8.761,8.761,0,0,1,8.75,8.75Z",
    transform: "translate(10.5 1.75)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133062",
    "data-name": "Path 133062",
    d: "M9.177,33.75a1.25,1.25,0,0,1-.884-.366l-5-5,1.767-1.767,2.866,2.866V20h2.5V32.5a1.249,1.249,0,0,1-.771,1.155A1.234,1.234,0,0,1,9.177,33.75Z",
    transform: "translate(0.823 5)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133063",
    "data-name": "Path 133063",
    d: "M9.5,20.75H7v-5A8.761,8.761,0,0,1,15.75,7h10V9.5h-10A6.257,6.257,0,0,0,9.5,15.75Z",
    transform: "translate(1.75 1.75)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133064",
    "data-name": "Path 133064",
    d: "M33.813,12.329,38.25,9l1.5,2-5,3.75a1.252,1.252,0,0,1-1.214.161L24,11.1V21.25a6.262,6.262,0,0,0,4.155,5.889L24.711,32.3l.321.214a1.245,1.245,0,0,1,.944.214L34,38.464l8.024-5.731a1.251,1.251,0,0,1,.943-.214l.322-.215-3.444-5.166A6.259,6.259,0,0,0,44,21.25v-15A6.257,6.257,0,0,0,37.75,0h-7.5A6.257,6.257,0,0,0,24,6.25V8.4Z",
    transform: "translate(6)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133065",
    "data-name": "Path 133065",
    d: "M34.477,32.191l5.55,1.294-.749-4.5Z",
    transform: "translate(8.619 7.248)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133066",
    "data-name": "Path 133066",
    d: "M29.052,60.039l3.685,3.685,3.685-3.685L33.146,33.12l-.376-.087-.446.128Z",
    transform: "translate(7.263 8.258)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133067",
    "data-name": "Path 133067",
    d: "M30.836,32.3l-5-3.335L24.884,34Z",
    transform: "translate(6.221 7.241)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133068",
    "data-name": "Path 133068",
    d: "M54.777,30.122l-6.935-3.152-1.507,1.005,1.243,7.454a1.25,1.25,0,0,1-1.234,1.456,1.32,1.32,0,0,1-.285-.033l-6.9-1.611L42.4,61.857a1.244,1.244,0,0,1-.356,1.035l-5,5a1.249,1.249,0,0,1-1.768,0l-5-5a1.244,1.244,0,0,1-.356-1.035l3.217-26.435L26,37.46a1.286,1.286,0,0,1-.343.047,1.252,1.252,0,0,1-1.229-1.483l1.526-8.067-1.484-.99L17.536,30.12a8.713,8.713,0,0,0-2.164,1.4,10.454,10.454,0,0,1,6.511,10.441l-.4,5.665a8.7,8.7,0,0,1-2.153,5.131L20.5,53.1a11.3,11.3,0,0,1,8.159,10.818v9.344h15V63.914A11.294,11.294,0,0,1,51.817,53.1l1.17-.334a8.713,8.713,0,0,1-2.153-5.132l-.405-5.665a10.448,10.448,0,0,1,6.513-10.441,8.7,8.7,0,0,0-2.165-1.4Zm-6.12,15.636h-5v-2.5h5Z",
    transform: "translate(3.843 6.742)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChiefofStaffHover);
export default __webpack_public_path__ + "static/media/ChiefofStaffHover.0192d97896f0822fd38ccbf1a627102a.svg";
export { ForwardRef as ReactComponent };